import { render } from "./CountriesIndex.vue?vue&type=template&id=e7984f22&ts=true"
import script from "./CountriesIndex.vue?vue&type=script&lang=ts"
export * from "./CountriesIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__